module.exports = __webpack_public_path__ + "img/noise_Off.f89e6398.png";